import { Button, Col, Form, Input, InputNumber, message, Modal, Popconfirm, Row, Select, Switch } from "antd";
import { Plat } from "../../../model/menudesign/Plat";
import { BiCheck, BiPlus, BiX } from "react-icons/bi";
import Colors from "../../../styles/Colors";
import { PostPlats } from "../../../dao/menudesign/PostPlats";
import { GetPlats } from "../../../dao/menudesign/GetPlats";
import { useEffect, useState , useContext} from "react";
import { PostIngredientsPlat } from "../../../dao/menudesign/PostIngredientsPlat";
import { GetIngredients } from "../../../dao/menudesign/GetIngredients";
import Ingredient from "../../../model/menudesign/Ingredient";
import { GetVariacio } from "../../../dao/menudesign/GetVariacio";
import { PostVariantsPlat } from "../../../dao/menudesign/PostVariantsPlat";
import Variacio from "../../../model/menudesign/Variacio";
import { PlatIngredient } from "../../../model/menudesign/PlatIngredient";
import { PlatVariacio } from "../../../model/menudesign/PlatVariacio";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import IngredientModal from "./IngredientModal";
import VariacioModal from "./VariacioModal";
import {BsEye, BsPlusCircle, BsReceiptCutoff} from "react-icons/bs";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {AuthContext} from "../../../config/AuthContext";
import toast, {Toaster} from "react-hot-toast";

interface IngredientModalProps {
    element: Plat;
    visible: boolean;
    page: string;
    editar?: boolean;
    onClose: (value: boolean) => void;
}

const PlatModal: React.FC<IngredientModalProps> = ({element, visible, page, editar, onClose}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user} = useContext(AuthContext);
    const [submitting, setSubmitting] = useState(false);
    const tipus = [{value: 'Primer plat',label: 'Primer plat',},{value: 'Segon plat',label: 'Segon plat',},{value: 'Complement',label: 'Complement',},{value: 'Postre',label: 'Postre',}]
    const grup = [{value: 'gra', label: 'gra'},{value: 'arros', label: 'arròs'},{value: 'verdura', label: 'verdura'},{value: 'cremes', label: 'cremes'},{value: 'sopes', label: 'sopes'},{value: 'pasta', label: 'pasta'}]
    const cuinat = [{value: 'bullir', label: 'Bullir'},{value: 'vapor', label: 'Vapor'},{value: 'forn', label: 'Forn'},{value: 'fregit', label: 'Fregit'},{value: 'cuinat', label: 'Cuinat'},{value: 'estofat', label: 'Estofat'},{value: 'planxa', label: 'Planxa'},{value: 'altres', label: 'Altres'}]
    const [ingredients, setIngredients] = useState<{ value: number; label: string; }[]>([]);
    const [platsList, setPlatsList] = useState<{ value: number; label: string; tipus: string }[]>([]);
    const [variants, setVariants] = useState<{ value: number; label: string; }[]>([]);
    const [platingList, setPlatingList] = useState<{ id_plat: number; ingredients: PlatIngredient[]; }[]>([]);
    const [nouElementI, setNouElementI] = useState(false);
    const [elementSelectedI, setElementSelectedI] = useState<Ingredient>(new Ingredient());
    const [nouElementV, setNouElementV] = useState(false);
    const [elementSelectedV, setElementSelectedV] = useState<Variacio>(new Variacio());
    const [platsFiltrats, setPlatsFiltrats] = useState<{ value: number; label: string; tipus: string }[]>([]);

    async function checkListas(){
        const dades = await GetPlats(page) || [];
        const ingredients = await GetIngredients(page);
        const variants = await GetVariacio(page);
        const platList = dades.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
            tipus : element.tipus,
        }));
        const ingList = ingredients.map((element: Ingredient) => ({
            value: element.id,
            label: element.nom,
        }));
        const varList = variants.map((element: Variacio) => ({
            value: element.id,
            label: element.nom,
        }));
        const plating_list = dades.map((element) => ({
            id_plat: element.id,
            ingredients: element.ingredients
        }));

        setPlatsList(platList);
        setIngredients(ingList);
        setVariants(varList);
        setPlatingList(plating_list);
    }

    function filtrarPlats(tipusSeleccionat : string) {
        const filtrados = platsList.filter(p => p.tipus === tipusSeleccionat);
        setPlatsFiltrats(filtrados);
    }
    const arraysEqual = (a: number[], b: number[]) => {
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
        }
        return true;
    };

    useEffect(() => {
        if (element) {
            // transformar lista de ingredientes del plat
            const ingArray = element.ingredients?.map((ing: PlatIngredient) => ({
            id_ingredient: ing.id_ingredient,
            qInfantil: Number(ing.qInfantil.toFixed(3)),
            qPrimaria: Number(ing.qPrimaria.toFixed(3)),
            qAdult: Number(ing.qAdult.toFixed(3)),
            per100: Number(ing.per100.toFixed(2)),
        })) || [];

        // transformar variacions si aplica
        
        let varArray: PlatVariacio[] = [];
        if (element.variacions && element.variacions.length > 0) {
        varArray = element.variacions.map((v: PlatVariacio) => ({
            id_plat: element.id, 
            id_variacio: v.id_variacio,
            id_alternativa: v.id_alternativa,
        }));
        }

        form.setFieldsValue({
        ...element,
        finalitzat: element.finalitzat === '1',
        ingredient_plat: ingArray,
        variacio_plat: varArray,
        });
        
        if (element.tipus) {
            filtrarPlats(element.tipus);
        }

    }
    }, [element, form, platsList]);

    const findPlatWithSameIngredients = (newIds: number[]): { id: number; nom: string } | null => {
    const sortedNew = [...newIds].sort((x, y) => x - y);

    for (const p of platingList) {
        const existingIds = p.ingredients.map(i => i.id_ingredient);
        const sortedExisting = [...existingIds].sort((x, y) => x - y);
        if (arraysEqual(sortedNew, sortedExisting)) {
        // buscar el nombre en platsList
        const found = platsList.find(pl => pl.value === p.id_plat);
        return { id: p.id_plat, nom: found ? found.label : '' };
        }
    }
    return null;
    };


    async function handleSubmit() {
        const formData = form.getFieldsValue();
        formData.estat = formData.estat ? 1 : 0;
        formData.finalitzat = formData.finalitzat ? '1' : '0';
        //Variants
        if (formData.variacio_plat) {
            const varArray = formData.variacio_plat.map((v: any) => ({
                id_variacio: v.id_variacio,
                id_alternativa: v.id_alternativa,
            }));
            formData.variacio_plat = JSON.stringify(varArray);
        }
        if (formData.ingredient_plat) {
            const ingArray = formData.ingredient_plat.map((ingredient: any) => ({
                id_ingredient: ingredient.id_ingredient,
                qInfantil: ingredient.qInfantil,
                qPrimaria: ingredient.qPrimaria,
                qAdult: ingredient.qAdult,
                per100: ingredient.per100,
            }));
            const newIds = ingArray.map((i: any) => i.id_ingredient);
            const duplicatePlat = element.id == 0 ? findPlatWithSameIngredients(newIds) : null;

        if (duplicatePlat) {
                Modal.confirm({
                    title: `Aquest plat té els mateixos ingredients que un altre plat existent: [${duplicatePlat.id}] ${duplicatePlat.nom}. Vols continuar?`,
                    okText: "Sí",
                    cancelText: "No",
                    onOk: async () => {
                        formData.ingredient_plat = JSON.stringify(ingArray);

                        console.log("Form Data (confirmant):", formData);
                        await PostPlats(formData,page, userId);
                        await onClose(true);
                        return true; 
                    },
                    onCancel: () => {
                        message.info("Enviament cancel·lat");
                    },
                    });
                return;
            }
            formData.ingredient_plat = JSON.stringify(ingArray);
        }
        

        console.log("Form Data:", formData);

        await PostPlats(formData,page, userId);
        await onClose(true);
    };

    async function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElementI(false);
        setNouElementV(false);
        checkListas();
    }
    async function handleCancel() {
        await onClose(false);
    };
    function afegirElementI(element: Ingredient) {
        setNouElementI(!nouElementI);
        setElementSelectedI(element);
    }
    function afegirElementV(element: Variacio) {
        setNouElementV(!nouElementV);
        setElementSelectedV(element);
    }

    function handleCloseModalI() {
        setNouElementI(false);
    }

    function handleCloseModalV() {
        setNouElementV(false);
    }
    useEffect(() => {
        checkListas();
    }, []);
    
    return (
        <Modal
        title="Crear/Editar Plat"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={1200}
        >
            <Toaster/>
            <Form form={form} onFinish={handleSubmit}  disabled={!editar} >
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Row  gutter={[8, 8]}>
                            <Col span={2}>
                                <Form.Item label="ID" name="id">
                                    <Input type="text" disabled={true}/>
                                </Form.Item>
                            </Col>
                            <Col span={18}>
                                <Form.Item label="Nom" name="nom"
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                    <Input type="text"/>
                                </Form.Item>
                            </Col>
                            <Col span={4}> 
                                <Form.Item label="Finalitzat" name="finalitzat">
                                    <Switch/>
                                </Form.Item>
                            </Col>
                            
                        </Row>
                        <Row  gutter={[8, 8]}>
                            <Col span={12}>
                                <Form.Item label="Tipus" name="tipus"
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                    <Select
                                        showSearch
                                        defaultValue={'primer'}
                                        placeholder="Selecciona un tipus de plat"
                                        optionFilterProp="label"
                                        options={tipus}
                                        onChange={(value) => filtrarPlats(value)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Grup" name="grup"
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                    <Select
                                        showSearch
                                        defaultValue={'verdura'}
                                        placeholder="Selecciona un grup de plat"
                                        optionFilterProp="label"
                                        options={grup}
                                    />
                                </Form.Item>
                            </Col>
                           
                        </Row>
                        <Row gutter={[8, 8]}>
                             <Col span={12}>
                                <Form.Item label="Cuinat" name="cuinat"
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                    <Select
                                        showSearch
                                        defaultValue={'forn'}
                                        placeholder="Selecciona com s'ha cuinat el plat"
                                        optionFilterProp="label"
                                        options={cuinat}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Cost" name="cost"
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                    <InputNumber min={0} step={0.01} style={{width:"100%"}}/>
                                </Form.Item>
                            </Col>

                        </Row>
                        
                    </Col>
                </Row>
                <hr/>
                    <Row>
                        <h6>Ingredients 
                            <Button title={"Crear nou ingredient"} style={{border:'0px'}} onClick={() =>afegirElementI(new Ingredient())}>
                                <BsPlusCircle color={Colors.colors.color2 }/>
                            </Button>  
                        </h6>
                    </Row>
                    <Form.List
                        name="ingredient_plat"
                        rules={[{
                            validator: async (_, ingredients) => {
                                if(!ingredients || ingredients.length < 1) return Promise.reject(new Error('Ha d\'haver-hi almenys un ingredient'));
                        },},]}
                    >
                    
                        {(fields, { add, remove }, { errors }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) =>(
                                <Row key={key} gutter={[16, 16]}>
                                    <Col span={6}>
                                    <Form.Item 
                                    {...restField}
                                    label="Ingredient" 
                                    name={[name, 'id_ingredient']}
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                        <Select
                                            showSearch
                                            optionFilterProp="label"
                                            options={ingredients}
                                        />
                                    </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item 
                                        {...restField}
                                        label="Qtat. infantil" 
                                        name={[name, 'qInfantil']}
                                        rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                            <InputNumber min={0} step={0.01}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item  
                                        {...restField}
                                        label="Qtat. primària" 
                                        name={[name, 'qPrimaria']}
                                        rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                            <InputNumber min={0} step={0.01}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item  
                                        {...restField}
                                        label="Qtat. adult" 
                                        name={[name, 'qAdult']}
                                        rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                            <InputNumber min={0} step={0.01}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item  
                                        {...restField}
                                        label="Percentatge" 
                                        name={[name, 'per100']}
                                        rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                            <Input prefix="%" type="number" min={0} max={100}/>
                                        </Form.Item>
                                    </Col>
                                    {fields.length > 1 ? (
                                        <Col span={2}>
                                            <Popconfirm
                                                title="Eliminant"
                                                description="Vols eliminar definitivament aquest element?"
                                                onConfirm={() => remove(name)}
                                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                                >
                                                    <MinusCircleOutlined
                                                        className="dynamic-delete-button"
                                                        style={{alignItems:'center', color:'red'}}
                                                    
                                                    />
                                            </Popconfirm>
                                            {/* <MinusCircleOutlined
                                                className="dynamic-delete-button"
                                                onClick={() => remove(name)}
                                                style={{alignItems:'center', color:'red'}}
                                               
                                            /> */}
                                        </Col>
                                    ) : null}
                                </Row>
                            ))}
                            
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    style={{ width: '25%',  borderColor:Colors.colors.color2, padding:'5px'}}
                                    icon={<PlusOutlined />}
                                >
                                    Afegeir ingredient
                                </Button>
                                <Form.ErrorList errors={errors} />
                            </Form.Item>
                        </>)}
                        
                    </Form.List>
                <hr/>
                <Row>
                    <h6>Variants (Menú)
                        <Button title={"Crear nova variant"} style={{border:'0px'}} onClick={() =>afegirElementV(new Variacio())}>
                            <BsPlusCircle color={Colors.colors.color2 }/>
                        </Button>  
                    </h6>
                </Row>
                <Row gutter={[16, 16]} >
                    <Col span={24}>
                        <Form.List
                        name="variacio_plat">
                        {(fields, { add, remove }, { errors }) => (
                            <>
                            {fields.map(({ key, name, ...restField }) => (
                                    <Row key={key} gutter={[16, 16]}>
                                    <Col span={10}>
                                        <Form.Item
                                        {...restField}
                                        label="Variant"
                                        name={[name, "id_variacio"]}
                                        rules={[{ required: true, message: "Selecciona una variant" }]}
                                        >
                                        <Select
                                            showSearch
                                            optionFilterProp="label"
                                            options={variants}
                                        />
                                        </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item
                                        {...restField}
                                        label="Plat alternatiu"
                                        name={[name, "id_alternativa"]}
                                        rules={[{ required: true, message: "Selecciona un plat" }]}
                                        >
                                        <Select
                                            showSearch
                                            optionFilterProp="label"
                                            options={platsFiltrats}
                                        />
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Popconfirm
                                            title="Eliminant"
                                            description="Vols eliminar definitivament aquest element?"
                                            onConfirm={() => remove(name)}
                                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                            >
                                                <MinusCircleOutlined
                                                    className="dynamic-delete-button"
                                                    style={{alignItems:'center', color:'red'}}
                                                    
                                                />
                                            </Popconfirm>
                                        {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                                    </Col>
                                    
                                    </Row>
                                ))}

                                <Form.Item>
                                    <Button
                                    style={{ width: '25%',  borderColor:Colors.colors.color2, padding:'5px'}}
                                    type="dashed"
                                    onClick={() => add()}
                                    icon={<PlusOutlined />}
                                    >
                                    Afegir variant
                                    </Button>
                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                                </>
                            )}
                            </Form.List>

                    </Col>
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} onClick={() => form.submit()} 
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
            {nouElementI && (
                <IngredientModal ingredient={elementSelectedI} onClose={handleCloseModal} visible={nouElementI} page={page} editar={true}/>
            )}
            {nouElementV && (
                <VariacioModal element={elementSelectedV} onClose={handleCloseModal} visible={nouElementV} editar={true} page={page}/>
            )}
        </Modal>
    )
};
export default PlatModal;